import { encryptStorage } from '../CustomStorage';
import { APP_CONSTANTS } from '../URLConstants';
import { ReactComponent as RFIDIcon } from '../icons/rfid.svg';
import { ReactComponent as SmsIcon } from '../icons/sms.svg';
import { ReactComponent as DashboardIcon } from '../icons/dashboard.svg';

export function toLowerCase(str) {
  if (str !== undefined && str !== null) return str.toLowerCase();
}

export function awsRekoPPeBodyTypes(bodyParts) {
  if (bodyParts !== null && bodyParts !== undefined) {
    switch (bodyParts.toUpperCase()) {
      case 'LEFT_HAND':
        return 'Left Hand';
      case 'RIGHT_HAND':
        return 'Right Hand';
      case 'HEAD':
        return 'Head';
      case 'FACE':
        return 'Face';
      case 'FACE_COVER':
        return 'Face Cover';
      case 'HEAD_COVER':
        return 'Head Cover';
      case 'HAND_COVER':
        return 'Hand Cover';
      default:
        return bodyParts;
    }
  }
}

export function Signout() {}

export function clearLocalDataOfUserLogins() {
  encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
  encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
  encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_IOT_CLIENT_ID);
  encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN);
}

export function Capitialize(text) {
  if (text === undefined && text === null) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function crossMarkString(inputString) {
  if (inputString === null || inputString === undefined) return '';

  if (inputString?.length > 5) {
    const lastFiveChars = inputString.slice(-5);
    return 'X'.repeat(5) + lastFiveChars;
  }

  return inputString;
}

export function parseValidationErrorMessage(error) {
  if (error?.response) {
    const responseData = error?.response?.data ?? {};

    if ('validationErrors' in responseData) {
      const validationErrors = responseData?.validationErrors ?? {};
      if ('message' in validationErrors) {
        return validationErrors?.message;
      }
      if ('errors' in validationErrors) {
        return validationErrors?.errors;
      }
    } else if ('errors' in responseData) {
      const errors = responseData?.errors ?? {};
      if (errors?.email) {
        return errors?.email;
      }
      if (errors?.password) {
        return errors?.password;
      }
    }
  }
  return error?.response?.data ?? 'Unknown error';
}

export function getTripStatusColor(statusColor) {
  if (statusColor === undefined || statusColor === null || statusColor === '') return '---';

  switch (statusColor.toUpperCase()) {
    case 'STARTED':
      return 'info';
    case 'SCHEDULED':
      return 'primary';
    case 'ARRIVED':
      return 'success';
    case 'COMPLETED':
      return 'success';
    case 'DELAYED':
      return 'error';
    case 'ONLINE':
      return 'success';
    case 'OFFLINE':
      return 'error';
    default:
      return 'info';
  }
}

export function getNotificationEventStatus(evenType) {
  if (evenType === undefined || evenType === null || evenType === '') return '---';

  switch (evenType.toUpperCase()) {
    case 'BACK_PLATE_OPEN':
      return 'Back Plate Open';
    case 'CABLE_CUT':
      return 'Cable Cut';
    case 'DEVICE_IS_NOT_READY':
      return 'Device is not ready';
    case 'DEVICE_SHUTDOWN_DUE_TO_LOW_BATTERY':
      return 'Device got shutdown due to low battery';
    case 'LOCK_CLOSED':
      return 'Lock Closed';
    case 'LOCK_OPENED':
      return 'Lock Opened';
    case 'BATTERY_LOW':
      return 'Battery Low';
    case 'SWITCH_ON':
      return 'Switch Bypass On';
    case 'SWITCH_OFF':
      return 'Switch Bypass Off';
    case 'UNLOCK_FAILED_DUE_TO_INVALID_RFID':
      return 'Unlock Failed (RFID)';
    case 'DEVICE_ERROR':
      return 'Device Error';
    case 'BATTERY_CHARGING':
      return 'Battery Charging';
    case 'REBOOT_DONE':
      return 'Reboot';
    case 'PSM_DATA':
      return 'Power Save Mode';
    case 'MOTION_DETECTED':
      return 'Motion Detected';
    case 'NO_MOTION_DETECTED':
      return 'No Motion Detected';
    case 'NOTIFICATION':
      return 'Notification';
    case 'RFID_ADDED':
      return 'RFID Card Added';
    case 'RFID_DELETED':
      return 'RFID Card Deleted';
    case 'RFID_ACTIVE':
      return 'RFID Card Activated';
    case 'RFID_INACTIVE':
      return 'RFID Card Inactive';
    case 'DEVICE_SLEEP':
      return 'Device is in Sleep Mode';
    case 'FLASH_CLEARED':
      return 'Device data flashed';
    case 'DEVICE_WAKE_UP':
      return 'Device Wake Up';
    case 'FETCH_FW_VERSION':
      return 'Device Version Fetched';
    case 'FACTORY_RESET':
      return 'Device setting reset';
    case 'RFID_CONFIGURED':
      return 'RFID Configured';
    case 'MOBILE_NO_ADDED':
      return 'Mobile Number Added';
    case 'MOBILE_NO_UPDATED':
      return 'Mobile Number Updated';
    case 'PASSWORD_SET':
      return 'Password Set';
    case 'FREQUENCY_UPDATED':
      return 'Device Frequency Updated';
    case 'NORMAL_MODE':
      return 'Device is in Normal Mode';
    case 'STANDBY_MODE':
      return 'Device is in StandBy Mode';
    case 'POWER_SAVE_MODE':
      return 'Power save mode';
    case 'DEVICE_STARTED':
      return 'Device Started';
    case 'GEOFENCE_CONFIG_ADDED':
      return 'GeoFence Configured';
    case 'GEN_CONFIG_ADDED':
      return 'Device Setting Updated';
    case 'DEVICE_DEVIATED':
      return 'Route Deviated';
    case 'WAYPOINT_MISSED':
      return 'Waypoint Missed';
    case 'VEHICLE_OVERSPEED':
      return 'Vehicle Over Speed';
    case 'FIRMWARE_UPDATED':
      return 'Firmware Updated';
    case 'FIRMWARE_COMMAND_RECEIVED':
      return 'Firmware Update Initialised';
    case 'NO_BLE_CUUID_FOUND':
      return 'Bluetooth Unavailable';
    default:
      return 'New Record Found';
  }
}

export const getLlockOpenedByChannelIcon = (channel) => {
  if (channel === undefined || channel === null || channel === '') return '';
  switch (channel.toUpperCase()) {
    case 'RFID':
      return RFIDIcon ? <RFIDIcon /> : null;
    case 'SMS':
      return SmsIcon ? <SmsIcon /> : null;
    case 'MQTT':
      return DashboardIcon ? <DashboardIcon /> : null;
    default:
      return '';
  }
};

export const deviceActionButtons = [
  {
    id: 1,
    btnName: 'Lock Open',
    url: 'lockOpen'
  },
  {
    id: 3,
    btnName: 'Sleep',
    url: 'deviceSleep'
  },
  // {
  //   id: 4,
  //   btnName: 'WakeUp',
  //   url: 'deviceWakeup'
  // },
  {
    id: 5,
    btnName: 'Erase Flash',
    url: 'deleteFlash'
  },
  // {
  //   id: 6,
  //   btnName: 'SwitchByPass ON',
  //   url: 'switchBypassOn'
  // },
  // {
  //   id: 7,
  //   btnName: 'SwitchByPass OFF',
  //   url: 'switchBypassOff'
  // },
  {
    id: 8,
    btnName: 'Reboot',
    url: 'reboot'
  }
];

export const getConfirmationMessage = (btnType) => {
  switch (btnType) {
    case 'lockOpen':
      return 'Do you really want to unlock this device?';
    case 'lockClose':
      return 'Are you certain you wish to lock this device?';
    case 'deviceSleep':
      return 'Are you certain you wish to put this device to sleep? !!';
    case 'deviceWakeup':
      return 'Are you sure you want to awaken this device?';
    case 'deleteFlash':
      return 'Are you sure you want to initiate the flashing process on this device?';
    case 'switchBypassOn':
      return 'Are you certain you wish to enable the bypass switch?';
    case 'switchBypassOff':
      return 'Are you absolutely sure you want to deactivate the bypass switch?';
    case 'reboot':
      return 'Are you certain you wish to initiate a reboot of this lock system?';
    case 'lvsOn':
      return 'Do you wish to activate the LVS?';
    case 'lvsOff':
      return 'Do you wish to deactivate the LVS?';
    default:
      return 'Are you sure you want to perform this action?';
  }
};

export const getTitle = (url) => {
  switch (url) {
    case 'lockOpen':
      return 'Lock Open';
    case 'lockClose':
      return 'Lock Close';
    case 'deviceSleep':
      return 'Device Sleep';
    case 'deviceWakeup':
      return 'Device Awake';
    case 'deleteFlash':
      return 'Flash Device';
    case 'switchBypassOn':
      return 'Switch By Pass ON';
    case 'switchBypassOff':
      return 'Switch By Pass OFF';
    case 'reboot':
      return 'Reboot';
    case 'lvsOn':
      return 'LVS on';
    case 'lvsOff':
      return 'LVS off';
    default:
      return 'Are you sure you want to perform this action?';
  }
};

export const getAlertMessage = (btnType) => {
  switch (btnType) {
    case 'lockOpen':
      return 'Lock Open successfully !!';
    case 'lockClose':
      return 'Lock closed successfully !!';
    case 'deviceSleep':
      return 'Device is in sleep now !!';
    case 'deviceWakeup':
      return 'Device is now waked up !!';
    case 'deleteFlash':
      return 'Device flashed successfully !!';
    case 'switchBypassOn':
      return 'Switched by pass on !!';
    case 'switchBypassOff':
      return 'Switched by pass off !!';
    case 'reboot':
      return 'Lock reboot successfully !!';
    case 'lvsOn':
      return 'LVS on !!';
    case 'lvsOff':
      return 'LVS off !!';
    default:
      return 'Task done';
  }
};

export const getErrorMessage = (actionType) => {
  switch (actionType) {
    case 'lockOpen':
      return 'Unlock attempt failed';
    case 'lockClose':
      return 'Lock process did not complete successfully';
    case 'deviceSleep':
      return 'Unable to put device to sleep';
    case 'deviceWakeup':
      return 'Device failed to wake up';
    case 'deleteFlash':
      return 'Flash deletion failed';
    case 'switchBypassOn':
      return 'Failed to activate switch bypass';
    case 'switchBypassOff':
      return 'Failed to deactivate switch bypass';
    case 'reboot':
      return 'Reboot failed';
    case 'lvsOn':
      return 'LVS on !!';
    case 'lvsOff':
      return 'LVS off !!';
    default:
      return 'Task done';
  }
};

export const LowBatteryThresholdRange = [5, 10, 15, 20, 25, 30];

export const PsmFrequencyData = [
  { value: 5, label: '5 min' },
  { value: 10, label: '10 min' },
  { value: 15, label: '15 min' },
  { value: 30, label: '30 min' },
  { value: 60, label: '1 hour' },
  { value: 120, label: '2 hour' },
  { value: 180, label: '3 hour' },
  { value: 240, label: '4 hour' },
  { value: 360, label: '6 hour' },
  { value: 480, label: '8 hour' },
  { value: 600, label: '10 hour' },
  { value: 720, label: '12 hour' },
  { value: 840, label: '14 hour' },
  { value: 960, label: '16 hour' },
  { value: 1080, label: '18 hour' },
  { value: 1200, label: '20 hour' },
  { value: 1320, label: '22 hour' },
  { value: 1440, label: '24 hour' },
  { value: 2880, label: '2 days' },
  { value: 4320, label: '3 days' },
  { value: 5760, label: '4 days' },
  { value: 7200, label: '5 days' },
  { value: 8640, label: '6 days' },
  { value: 10080, label: '7 days' }
];
